export default __webpack_public_path__ + "static/media/ic_vn_flag.76cb34d8.svg";